import React from 'react';
import FleetDashboard from '../../../Components/Dashboard/Fleet';

export default function Fleet() {
    return (
        <div className='page-body'>
            <FleetDashboard />
        </div>
    );
}
